module.exports = __webpack_public_path__ + "img/step4a-fr@2x.264dd421.webp";